import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enAnalyse from './locales/en/analyse.json';
import enCareers from './locales/en/careers.json';
import enCommon from './locales/en/common.json';
import enContactUs from './locales/en/contactUs.json';
import enForms from './locales/en/forms.json';
import enHome from './locales/en/home.json';
import enMisc from './locales/en/misc.json';
import enProduct from './locales/en/product.json';
import enRequestDemo from './locales/en/requestDemo.json';
import enSolutionDataCentre from './locales/en/solutionDataCentre.json';
import enSolutionEnergyBuyer from './locales/en/solutionEnergyBuyer.json';
import enSolutionEpc from './locales/en/solutionEpc.json';
import enSolutionLandlord from './locales/en/solutionLandlord.json';
import nlAnalyse from './locales/nl/analyse.json';
import nlCareers from './locales/nl/careers.json';
import nlCommon from './locales/nl/common.json';
import nlContactUs from './locales/nl/contactUs.json';
import nlForms from './locales/nl/forms.json';
import nlHome from './locales/nl/home.json';
import nlMisc from './locales/nl/misc.json';
import nlProduct from './locales/nl/product.json';
import nlRequestDemo from './locales/nl/requestDemo.json';
import nlSolutionDataCentre from './locales/nl/solutionDataCentre.json';
import nlSolutionEnergyBuyer from './locales/nl/solutionEnergyBuyer.json';
import nlSolutionEpc from './locales/nl/solutionEpc.json';
import nlSolutionLandlord from './locales/nl/solutionLandlord.json';

export const SUPPORTED_LANGUAGES = ['en', 'nl'];
export const DEFAULT_LANGUAGE = 'en';
export const LANGUAGE_STORAGE_KEY = 'inrange.language';

const resources = {
    en: {
        analyse: enAnalyse,
        careers: enCareers,
        common: enCommon,
        contactUs: enContactUs,
        forms: enForms,
        home: enHome,
        misc: enMisc,
        product: enProduct,
        requestDemo: enRequestDemo,
        solutionDataCentre: enSolutionDataCentre,
        solutionEnergyBuyer: enSolutionEnergyBuyer,
        solutionEpc: enSolutionEpc,
        solutionLandlord: enSolutionLandlord
    },
    nl: {
        analyse: nlAnalyse,
        careers: nlCareers,
        common: nlCommon,
        contactUs: nlContactUs,
        forms: nlForms,
        home: nlHome,
        misc: nlMisc,
        product: nlProduct,
        requestDemo: nlRequestDemo,
        solutionDataCentre: nlSolutionDataCentre,
        solutionEnergyBuyer: nlSolutionEnergyBuyer,
        solutionEpc: nlSolutionEpc,
        solutionLandlord: nlSolutionLandlord
    }
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: DEFAULT_LANGUAGE,
        supportedLngs: SUPPORTED_LANGUAGES,
        ns: [
            'analyse',
            'careers',
            'common',
            'contactUs',
            'forms',
            'home',
            'misc',
            'product',
            'requestDemo',
            'solutionDataCentre',
            'solutionEnergyBuyer',
            'solutionEpc',
            'solutionLandlord'
        ],
        defaultNS: 'common',
        interpolation: { escapeValue: false },
        react: { useSuspense: false },
        detection: {
            order: ['localStorage', 'navigator'],
            lookupLocalStorage: LANGUAGE_STORAGE_KEY,
            caches: ['localStorage']
        }
    });

export default i18n;
